import type { RouteObject } from "react-router-dom";
import RouteTransition from "@/components/feature/RouteTransition";

// All pages render through RouteTransition, which keeps the outgoing page
// mounted during its fade-out before swapping to the incoming page.
const routes: RouteObject[] = [
  { path: "*", element: <RouteTransition /> },
];

export default routes;